import React, { useState, useEffect } from "react";
import "./index.css";
import "./App.scss";
import { Helmet } from "react-helmet";

import Header from "./components/Header.jsx";
import Hero from "./components/Hero.jsx";
import About from "./components/About.jsx";
import WhyUs from "./components/WhyUs.jsx";
import CountdownSection from "./components/CountdownSection";
import Services from "./components/ServiceArea.jsx";
import WhatYouGet from "./components/WhatYouGet.jsx";
import Gallery from "./components/Gallery.jsx";
import Testimonials from "./components/Testimonials.jsx";
import Pricing from "./components/Pricing.jsx";
import FAQ from "./components/FAQ.jsx";
import Contact from "./components/ContactForm.jsx";
import Footer from "./components/Footer.jsx";
import WhatsAppButton from "./components/FloatingWhatsApp.jsx";

function App() {
  const [hideWidgets, setHideWidgets] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      <Helmet>
        <title>Toyibah Aqiqah - Layanan Aqiqah Berkualitas di Jakarta</title>
        <meta name="description" content="Pesan layanan aqiqah lengkap dengan paket hemat, dokumentasi profesional, dan pengiriman gratis. Hubungi kami untuk aqiqah bayi yang islami dan berkesan." />
        <meta name="keywords" content="aqiqah, layanan aqiqah, pesan aqiqah online, aqiqah Jakarta, paket aqiqah, aqiqah bayi" />
        <meta name="author" content="Toyibah Aqiqah" />
        <meta property="og:title" content="Toyibah Aqiqah - Layanan Aqiqah Berkualitas" />
        <meta property="og:description" content="Pesan layanan aqiqah lengkap dengan paket hemat dan pengiriman gratis." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://toyibahaqiqah.id" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://toyibahaqiqah.id" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Toyibah Aqiqah",
            "description": "Layanan aqiqah berkualitas dengan paket lengkap dan pengiriman gratis.",
            "url": "https://toyibahaqiqah.id",
            "telephone": "+6281295138575",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Jl. Cimpaeun Tapos Gg Bakti Suci RT 01 RW 03 No 17",
              "addressLocality": "Tapos Depok",
              "addressRegion": "Jawa Barat",
              "addressCountry": "ID"
            },
            "serviceType": "Aqiqah Services"
          })}
        </script>
      </Helmet>
      {/* 🧭 Tambahkan Header di paling atas */}
      <Header />

      {/* 🏠 1. Hero - Fokus headline & CTA pertama */}
      <Hero />

      {/* 🚚 6. Services */}
      <Services />

       {/* 💸 10. Pricing */}
      <Pricing setHideWidgets={setHideWidgets} />

      {/* 🕌 2. Countdown Section */}
      {!(hideWidgets && isMobile) && <CountdownSection />}

      {/* 💖 3. About */}
      <About />

      {/* 🌟 4. WhyUs */}
      <WhyUs />

      {/* 🎁 7. WhatYouGet */}
      <WhatYouGet />

      {/* 📸 8. Gallery */}
      <Gallery />

      {/* 💬 9. Testimonials */}
      <Testimonials />

      {/* ❓ 12. FAQ */}
      {!(hideWidgets && isMobile) && <FAQ />}

      {/* 📞 13. Contact */}
      <Contact />

      {/* ⚓ 14. Footer */}
      <Footer />

      {/* 💬 15. WhatsApp Floating Button */}
      {!(hideWidgets && isMobile) && <WhatsAppButton />}
    </>
  );
}

export default App;
